import { render, staticRenderFns } from "./attach-documents.component.vue?vue&type=template&id=65da2591&"
import script from "./attach-documents.component.vue?vue&type=script&lang=ts&"
export * from "./attach-documents.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports